// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HZlt","label":"styles_label___6htA"};